export default "/img/CD.cd92bfc08b1ee58da7a6778d5d9b5930.png";